export default "__VITE_ASSET__Px8oQO65__"